import { RenderConfigurations } from './canvas-renderer';
import { createForeignObjectSVG, loadSerializedSVG } from '../../core/features';
import { asString } from '../../css/types/color-utilities';
import { Context } from '../../core/context';

export class ForeignObjectRenderer {
    canvas: HTMLCanvasElement;
    ctx: CanvasRenderingContext2D;
    options: RenderConfigurations;
    private readonly context: Context;

    constructor(context: Context, options: RenderConfigurations) {
        this.context = context;
        this.options = options;
        this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
        const ctx = this.canvas.getContext('2d');
        if (!ctx) {
            throw new Error('Failed to get 2D rendering context from canvas');
        }
        this.ctx = ctx;
        this.canvas.width = Math.floor(options.width * options.scale);
        this.canvas.height = Math.floor(options.height * options.scale);
        this.canvas.style.width = `${options.width}px`;
        this.canvas.style.height = `${options.height}px`;

        this.ctx.scale(this.options.scale, this.options.scale);
        this.ctx.translate(-options.x, -options.y);
        this.context.logger.debug(
            `EXPERIMENTAL ForeignObject renderer initialized (${options.width}x${options.height} at ${options.x},${options.y}) with scale ${options.scale}`
        );
    }

    async render(element: HTMLElement): Promise<HTMLCanvasElement> {
        if (this.options.signal?.aborted) {
            throw new DOMException('The operation was aborted.', 'AbortError');
        }

        const svg = createForeignObjectSVG(
            this.options.width * this.options.scale,
            this.options.height * this.options.scale,
            this.options.scale,
            this.options.scale,
            element
        );

        const img = await loadSerializedSVG(svg);

        if (this.options.backgroundColor) {
            this.ctx.fillStyle = asString(this.options.backgroundColor);
            this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
        }

        this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);

        return this.canvas;
    }
}
